import React, {PropsWithChildren, ReactElement} from 'react';
import {Tab, Tabs} from "@mui/material";
import {TabPanel} from "./tab-panel";
import {useTabs} from "./hooks/use-tabs";

type TabbedProps = {
    label: string;
};

const Tabbed = ({initialTab = 0, children}: { initialTab?: number, children: ReactElement<TabbedProps> | ReactElement<TabbedProps>[] }) => {
    const [activeTab, setActiveTab] = useTabs(initialTab);
    return (
        <>
            <Tabs variant="scrollable" value={activeTab} onChange={setActiveTab}>
                {React.Children.map(children, (child, index) => (
                    <Tab label={child.props.label}></Tab>
                ))}
            </Tabs>

            {React.Children.map(children, (child, index) => (
                <TabPanel index={index} value={activeTab}>
                    {child}
                </TabPanel>
            ))}
        </>
    );
};

Tabbed.Tab = ({children}: PropsWithChildren<TabbedProps>) => <>{children}</>;

export default Tabbed;